import { makeRequest } from '../client';

export const getRewards = (restaurantId) =>
  makeRequest('reward', 'getRewards', { restaurantId });
